/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Slider On Product Page

  $('.slider-con').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


(function() {
// estimate the delivery date
if(document.getElementById('fromDate')) {
  
  var dateStart = 3;
  var dateEnd = 4;

  var fromDate = Date.today().addDays(dateStart);
  if (fromDate.is().sunday()) { 
    fromDate = fromDate.next().monday();
  }
  var toDate = Date.today().addDays(dateEnd);
  if (toDate.is().sunday()) { 
    toDate = toDate.next().monday(); 
  }
  document.getElementById('fromDate').innerHTML = fromDate.toString('M月dd');
  document.getElementById('toDate').innerHTML = toDate.toString('M月dd');
}
})();

(function() {
// estimate the delivery date
if(document.getElementById('PreOrderfromDate')) {
  
  var dateStart = 7;
  var dateEnd = 9;

  var fromDate = Date.today().addDays(dateStart);
  if (fromDate.is().sunday()) { 
    fromDate = fromDate.next().monday();
  }
  var toDate = Date.today().addDays(dateEnd);
  if (toDate.is().sunday()) { 
    toDate = toDate.next().monday(); 
  }
  document.getElementById('PreOrderfromDate').innerHTML = fromDate.toString('M月dd');
  document.getElementById('PreOrdertoDate').innerHTML = toDate.toString('M月dd');
}
})();


document.addEventListener('DOMContentLoaded', function() {
  const carouselWrapper = document.querySelector('.carousel-wrapper');
  const carouselItems = document.querySelectorAll('.carousel-item');
  const prevButton = document.querySelector('.carousel-prev');
  const nextButton = document.querySelector('.carousel-next');
  
  let currentIndex = 0;
  const totalItems = carouselItems.length;
  const itemsToShow = 3;
  const slideInterval = 2000;
  let autoSlideInterval;

  let startX = 0;
  let endX = 0;
  let isDragging = false;
  let longPressTimeout;

  function updateCarousel() {
    const offset = currentIndex * (100 / itemsToShow);
    carouselWrapper.style.transform = `translateX(-${offset}%)`;
  }

  function goToNextSlide() {
    if (currentIndex < totalItems - itemsToShow) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    updateCarousel();
  }

  function goToPrevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = totalItems - itemsToShow;
    }
    updateCarousel();
  }

  function startAutoSlide() {
    autoSlideInterval = setInterval(goToNextSlide, slideInterval);
  }

  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }

  function handleLongPress(event) {
    stopAutoSlide();
    // Cleanup long press timeout
    clearTimeout(longPressTimeout);
  }

  // Manual controls
  prevButton.addEventListener('click', function() {
    stopAutoSlide();
    goToPrevSlide();
    startAutoSlide();
  });

  nextButton.addEventListener('click', function() {
    stopAutoSlide();
    goToNextSlide();
    startAutoSlide();
  });

  // Swipe/Drag detection
  carouselWrapper.addEventListener('touchstart', function(event) {
    stopAutoSlide();
    startX = event.touches[0].clientX;
    isDragging = false;

    // Set up long press timeout
    longPressTimeout = setTimeout(() => {
      handleLongPress(event);
    }, 500); // Adjust time as needed for long press
  });

  carouselWrapper.addEventListener('touchmove', function(event) {
    endX = event.touches[0].clientX;
    isDragging = true;
  });

  carouselWrapper.addEventListener('touchend', function() {
    clearTimeout(longPressTimeout); // Clear long press timeout on touch end
    if (isDragging) {
      if (startX - endX > 5) {
        goToNextSlide();
      } else if (endX - startX > 5) {
        goToPrevSlide();
      }
    }
    startAutoSlide();
  });

  // Mouse drag detection
  carouselWrapper.addEventListener('mousedown', function(event) {
    stopAutoSlide();
    startX = event.clientX;
    isDragging = false;
    document.body.style.userSelect = 'none'; // Disable text selection
  });

  carouselWrapper.addEventListener('mousemove', function(event) {
    if (event.buttons === 1) { // Mouse is down
      endX = event.clientX;
      isDragging = true;
    }
  });

  carouselWrapper.addEventListener('mouseup', function() {
    if (isDragging) {
      if (startX - endX > 5) {
        goToNextSlide();
      } else if (endX - startX > 5) {
        goToPrevSlide();
      }
    }
    startAutoSlide();
    document.body.style.userSelect = ''; // Re-enable text selection
  });

  carouselWrapper.addEventListener('mouseleave', function() {
    if (isDragging) {
      if (startX - endX > 5) {
        goToNextSlide();
      } else if (endX - startX > 5) {
        goToPrevSlide();
      }
    }
    document.body.style.userSelect = ''; // Re-enable text selection
  });

  // Ensure clicking on an image works properly
  carouselWrapper.addEventListener('click', function(event) {
    const target = event.target.closest('.carousel-item a');
    if (target) {
      window.location.href = target.href;
    }
  });

  // Auto slide
  startAutoSlide();

  updateCarousel();
});



// mobile-nav.js
document.addEventListener('DOMContentLoaded', function () {
  // Find the "Shop by collection" menu button and the banners container
  const shopByCollectionButton = Array.from(document.querySelectorAll('.SidebarMenu__Nav--primary .Collapsible__Button')).find(button => button.textContent.includes('Shop by collection'));
  const collectionBanners = document.getElementById('collection-banners');

  if (shopByCollectionButton && collectionBanners) {
    // Add click event listener to toggle banners visibility
    shopByCollectionButton.addEventListener('click', function () {
      const isExpanded = shopByCollectionButton.getAttribute('aria-expanded') === 'true';
      shopByCollectionButton.setAttribute('aria-expanded', !isExpanded);

      if (isExpanded) {
        collectionBanners.style.display = 'none';
      } else {
        collectionBanners.style.display = 'block';
      }
    });
  }
});

  document.addEventListener('DOMContentLoaded', function() {
    // Select the "Shop by collection" button
    const shopByCollectionButton = document.getElementById('shop-by-collection');
    
    if (shopByCollectionButton) {
      // Find the next Collapsible__Inner element and hide its content
      shopByCollectionButton.addEventListener('click', function() {
        const collapsibleInner = shopByCollectionButton.nextElementSibling;
        
        if (collapsibleInner) {
          const subLinks = collapsibleInner.querySelectorAll('.Collapsible__Button');
          subLinks.forEach(link => {
            link.style.display = 'none'; // Hide sub-links
          });
        }
      });
    }
  });


// mobile-nav-loookbook.js
document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  const slides = Array.from(track.children);
  const nextButton = document.querySelector('.carousel-button.right');
  const prevButton = document.querySelector('.carousel-button.left');
  
  const slideWidth = slides[0].getBoundingClientRect().width;

  // Arrange the slides next to each other
  slides.forEach((slide, index) => {
    slide.style.left = slideWidth * index + 'px';
  });

  let currentSlide = 0;
  const maxIndex = slides.length - 2; // Adjust the max index to prevent blank space at the end

  // Move to the target slide
  const moveToSlide = (track, targetSlideIndex) => {
    const targetSlide = slides[targetSlideIndex];
    track.style.transform = 'translateX(-' + targetSlide.style.left + ')';
    currentSlide = targetSlideIndex; // Update the current slide index
  };

  // Click right (Next Button)
  nextButton.addEventListener('click', e => {
    if (currentSlide < maxIndex) {
      moveToSlide(track, currentSlide + 1);
    }
  });

  // Click left (Previous Button)
  prevButton.addEventListener('click', e => {
    if (currentSlide > 0) {
      moveToSlide(track, currentSlide - 1);
    }
  });

  // Touch swipe functionality for mobile
  let startX = 0;
  let isSwiping = false;

  // Track the touch start position
  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    isSwiping = true;
  });

  // Detect touch move to understand swipe
  track.addEventListener('touchmove', function(e) {
    if (isSwiping) {
      const currentX = e.touches[0].clientX;
      const swipeDistance = startX - currentX;

      // Only trigger on a significant swipe distance (e.g., >50px)
      if (swipeDistance > 5) {
        // Swipe left (next)
        if (currentSlide < maxIndex) {
          moveToSlide(track, currentSlide + 1);
        }
        isSwiping = false; // End swipe
      } else if (swipeDistance < -5) {
        // Swipe right (previous)
        if (currentSlide > 0) {
          moveToSlide(track, currentSlide - 1);
        }
        isSwiping = false; // End swipe
      }
    }
  });

  // Reset swiping state when touch ends
  track.addEventListener('touchend', function() {
    isSwiping = false;
  });
});

// product video autoplay
  (function () {
  function setupProductVideoAutoplay() {
    var slideshow = document.querySelector('.Product__Slideshow');
    if (!slideshow) return;

    // Target your existing video element
    var videos = slideshow.querySelectorAll('video.custom_video');
    if (!videos.length) return;

    // Force correct attributes for autoplay on mobile Safari
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('loop', '');
      v.setAttribute('autoplay', '');
      v.controls = false;
      v.removeAttribute('controls');
    });

    function playVideoInSelectedSlide() {
      // Pause all first
      videos.forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });

      // Find selected slide and play the video inside it
      var selected = slideshow.querySelector('.Product__SlideItem.is-selected');
      if (!selected) return;

      var v = selected.querySelector('video.custom_video');
      if (!v) return;

      // Try play (Safari may require a tick)
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    // Run once on load
    playVideoInSelectedSlide();

    // Hook into Flickity if available
    if (slideshow.flickity) {
      slideshow.flickity.on('change', playVideoInSelectedSlide);
      slideshow.flickity.on('settle', playVideoInSelectedSlide);
    } else {
      // Fallback: observe class changes (when Flickity toggles is-selected)
      var mo = new MutationObserver(function () {
        playVideoInSelectedSlide();
      });
      mo.observe(slideshow, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  document.addEventListener('DOMContentLoaded', setupProductVideoAutoplay);
})();

  // Blog FAQ
const initFaq = () => {
  const questions = document.querySelectorAll('.faq-question');
  
  questions.forEach(question => {
    // Only attach the listener if it hasn't been attached yet
    if (question.dataset.faqListener === 'true') return;
    question.dataset.faqListener = 'true';

    question.addEventListener('click', function() {
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      const answer = this.nextElementSibling;

      // Toggle state
      this.setAttribute('aria-expanded', !isOpen);

      if (!isOpen) {
        // We set a large enough maxHeight or the exact scrollHeight
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = "0";
      }
    });
  });
};

// Run on initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaq);
} else {
  initFaq();
}

// Shopify specific: If your theme uses AJAX to load pages, 
// this ensures the script runs when the user navigates.
document.addEventListener('shopify:section:load', initFaq);


//* ── FAQ Accordion ──
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(function (button) {
    button.addEventListener('click', function () {
      this.parentElement.classList.toggle('active');
    });
  });
});